
const toggleNav = () => {
  $(".pages-header__menu-mobile").toggleClass("open");
  $("#navigation").slideToggle(500).show();
};

$(".pages-header__menu-mobile").click(function () {
  toggleNav();
});

$("#navigation").click(function () {
  toggleNav();
});



// WEBPACK FOOTER //
// ./app/blocks/header/header.js